module.exports = __webpack_public_path__ + "media/images/ico_formu-44354408dd7c40eb563009a00c496d19.svg";